import React, { useEffect, useState } from "react";
import {
  FacebookShareButton,
  FacebookIcon,
  WhatsappShareButton,
  WhatsappIcon,
  TelegramShareButton,
  TelegramIcon,
  TwitterShareButton,
  TwitterIcon,
} from "next-share";
import Image from "next/image";

export default function SocialMediaCta() {
  const [url, setUrl] = useState("");
  useEffect(() => {
    setUrl(window.location.href);
  }, []);
  return (
    <div>
      <section
        className="relative flex items-center justify-center px-5 py-20 bg-no-repeat bg-cover "
        style={{
          backgroundPosition: "50% 20%",
        }}
      >
        <Image fill src={'/images/newsletterCta.jpg'} alt={'Newsletter'} className="object-cover object-center" />

        <div
          className="absolute z-20 w-full h-full"
          style={{ background: "rgb(0, 111, 185, 0.9)" }}
        />

        <div
          data-wow-duration="1s"
          data-wow-delay="0.5s"
          className="z-20 w-full max-w-xl !mx-auto  md:max-w-5xl 2xl:max-w-7xl "
        >
          <div>
            <div
              action="#"
              noValidate
              className="flex flex-col items-center justify-center md:flex-row md:justify-center gap-x-2"
            >
              <div className="flex flex-col w-full text-white">
                <h2 className="relative z-10 max-w-2xl 2xl:max-w-3xl md:mt-0 text-center md:text-left text-xl md:text-2xl font-bold wow animate__animated animate__fadeIn">
                  ¿Te pareció útil esta información? <br /> Suscríbete a nuestro
                  boletín o compártela
                </h2>
              </div>
              <div className="flex gap-5 p-5 mt-5 bg-gray-100 w-fit rounded-xl">
                <FacebookShareButton
                  url={url}
                  quote={"Actionis Consulting"}
                  hashtag={"#nextshare"}
                >
                  <FacebookIcon size={50} round />
                </FacebookShareButton>

                <WhatsappShareButton
                  url={url}
                  title={"Actionis Consulting"}
                  separator=":: "
                >
                  <WhatsappIcon size={50} round />
                </WhatsappShareButton>

                <TelegramShareButton url={url} title={"Actionis Consulting"}>
                  <TelegramIcon size={50} round />
                </TelegramShareButton>

                <TwitterShareButton url={url} title={"Actionis Consulting"}>
                  <TwitterIcon size={50} round />
                </TwitterShareButton>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
